import { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { HeadlineColors, HeadlineTypes, HeadlineOptions } from '.';
import st from './Headline.module.scss';

interface IHeadlineProps extends HTMLAttributes<HTMLHeadingElement> {
	/** Тип заголовка */
	type?: HeadlineTypes;
	/** Цвет заголовка */
	color?: HeadlineColors;
};

/** Компонента выводит предварительно стилизованные заголовки */
const Headline = forwardRef<HTMLHeadingElement,IHeadlineProps>( (props, ref) => {

	const {
		type = 'default', color = 'std',
		className, children, ...otherProps
	} = props;

	const Tag = HeadlineOptions[type].tag;
	const classes = classNames(st.headline, HeadlineOptions[type].className, st[color], className);

	return (
		<Tag className={classes} {...otherProps} ref={ref}>
			{children}
		</Tag>
	);
});

export default Headline;
